import { useCallback, useState } from 'react';
import { AxiosError } from 'axios';

const useApiRequest = () => {
  const [isLoading, setIsLoading] = useState(false);

  const handleRequest = useCallback(
    async (
      requestHandler: () => Promise<any>,
      handleError?: (data?: any) => void,
    ) => {
      try {
        setIsLoading(true);

        await requestHandler();
      } catch (e) {
        if (e instanceof AxiosError) {
          handleError?.(e.response?.data);
        }
      } finally {
        setIsLoading(false);
      }
    },
    [],
  );

  return {
    request: handleRequest,
    isLoading,
  };
};

export default useApiRequest;
